import { type FeatureFlagControlEntityKind } from './types';

/**
 * How each entity's id reaches the flag provider when the services evaluate a
 * flag, which decides what a toggle has to change.
 *
 * The services send a user context keyed by the user id, carrying the supplier
 * as the `supplierId` attribute and the buyers as `buyerIds`. A supplier or a
 * buyer is never the context key, so it can only be targeted through a rule
 * condition on its attribute; only a user can be listed by key.
 */
export interface EntityDescriptor {
  kind: FeatureFlagControlEntityKind;
  /** The word used in copy, e.g. "distributor". */
  label: string;
  /** The attribute rule conditions match on; `key` for the context key. */
  clauseAttribute: string;
  isContextKey: boolean;
  contextKind: string;
}

const DESCRIPTORS: Record<FeatureFlagControlEntityKind, EntityDescriptor> = {
  supplier: {
    kind: 'supplier',
    label: 'distributor',
    clauseAttribute: 'supplierId',
    isContextKey: false,
    contextKind: 'user',
  },
  buyer: {
    kind: 'buyer',
    label: 'buyer',
    // An array attribute: a condition matches when any element is listed.
    clauseAttribute: 'buyerIds',
    isContextKey: false,
    contextKind: 'user',
  },
  user: {
    kind: 'user',
    label: 'user',
    clauseAttribute: 'key',
    isContextKey: true,
    contextKind: 'user',
  },
};

export const getEntityDescriptor = (
  kind: FeatureFlagControlEntityKind
): EntityDescriptor => DESCRIPTORS[kind];
